import axios from 'axios';

const API_URL = 'https://api-agamhive.agamvanigam.com/bomtypes';

const getAuthToken = () => {
  return localStorage.getItem('token');
};

interface FetchParams {
  page?: number;
  limit?: number;
  search?: string;
  filter?: Record<string, string | number | boolean>;  // step1 
}

export const createBomType = async (data: { type: string; status: string }) => {
  const token = getAuthToken();
  const response = await axios.post(API_URL, data, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data?.data?.data; 
};

export const getBomTypes = async (params: FetchParams = {}) => {
  const token = getAuthToken();
  try {
    const queryParams = new URLSearchParams({
        page: (params.page || 1).toString(),
        limit: (params.limit || 10).toString(),
        ...(params.search ? { search: params.search } : {}),
        ...(params.filter  // step 2
          ? Object.fromEntries(Object.entries(params.filter).map(([key, value]) => [key, String(value)]))
          : {}),});

    console.log(`url for item list : ${API_URL}?${queryParams}`);
    
    const response = await fetch(`${API_URL}/?${queryParams}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    const jsonResponse = await response.json();
    if (!response.ok) {
        return { error: jsonResponse.msg || "Failed to fetch items" };
    }

    return jsonResponse;
} catch (error) {
    return { error: "Network error. Please try again." };
}};

export const updateBomType = async (id: string, data: { type: string; status: string }) => {
  const token = getAuthToken();
  const response = await axios.patch(`${API_URL}/${id}`, data, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response.data?.data?.data; 
};

export const deleteBomType = async (id: string) => {
  const token = getAuthToken();
  await axios.delete(`${API_URL}/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
};
